<div class="pad-top" *ngIf="project() as project">
  <fw-grid>
    <fw-grid-item [cols]="9" variant="page-shaded">
      <project-statistics [loading]="project === undefined" [statistics]="project?.stats?.number_of"></project-statistics>
      <div class="card description-card">
        <h1 class="font-card-header has-button">
          {{ 'projectManage.tabs.description' | translate }}
          <span *ngIf="canEditDescription()">
            <span
              class="markdown-hint">{{ 'projectManage.description.markdownSupported' | translate }}</span>
            <fw-button *ngIf="!editingDescription" variant="outline" color="primary"
              (click)="editingDescription = true" leftIcon="edit">
              {{ 'common.actions.edit' | translate }}
            </fw-button>
          </span>
        </h1>
        <div class="markdown-container">
          <ng-container *ngIf="project; else loadingDescription">
            <ng-container *ngIf="!editingDescription; else editDescription">
              <p *ngIf="descriptionHtml" [innerHTML]="descriptionHtml"></p>
              <div *ngIf="!descriptionHtml" class="empty-description">
                <fw-icon class="bright-blue md">edit</fw-icon>
                <p>{{ 'projectManage.description.empty' | translate }}</p>
                <fw-button *ngIf="canEditDescription()" (click)="editingDescription = true">
                  {{ 'projectManage.description.addDescription' | translate }}
                </fw-button>
              </div>
            </ng-container>
          </ng-container>
          <ng-template #loadingDescription>
            <fw-loading></fw-loading>
          </ng-template>
          <ng-template #editDescription>
            <textarea name="description" data-id="project-description-content"
              [formControl]="projectDescription"></textarea>
            <fw-grid *ngIf="project">
              <fw-grid-item [cols]="4">
                <p class="text-muted">
                  <small>{{ 'common.labels.ofCharacters' | translate | interpolate:projectDescription.value?.length||0:10000 }}</small>
                </p>
              </fw-grid-item>
              <fw-grid-item [cols]="8">
                <fw-button variant="outline" color="slate" (click)="editingDescription = false">
                  {{ 'common.actions.cancel' | translate }}
                </fw-button>
                <fw-button color="primary" (click)="saveProjectDescription(project)"
                  [disabled]="projectDescription.invalid">
                  {{ 'common.actions.save' | translate }}
                </fw-button>
              </fw-grid-item>
            </fw-grid>
          </ng-template>
        </div>
      </div>
    </fw-grid-item>
    <fw-grid-item [cols]="3" variant="page-shaded">
      @if (ohifEnabled) {
        <div class="card description-right-card">
          <h1 class="font-card-header">{{ 'projectManage.description.viewer' | translate }}</h1>
          <fw-button [fullWidth]="true" (click)="viewProjectStudies()">
            {{ 'projectManage.description.viewerStudyList' | translate }}
          </fw-button>
        </div>
      }
      <div class="card description-right-card">
        <h1 class="font-card-header">{{ 'projectManage.description.tipHeader' | translate }}</h1>
        <p>{{ 'projectManage.description.tipP1' | translate }}</p>
        <p>{{ 'projectManage.description.tipP2' | translate }}</p>
      </div>
    </fw-grid-item>
  </fw-grid>
</div>
